import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import PrintIcon from "@mui/icons-material/Print";
import DownloadIcon from "@mui/icons-material/Download";

export default function PrintPreparationModal({
  open,
  ready = false,
  onPrint,
  isMobile = false,
}) {
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: "24px",
          maxWidth: "400px",
          width: "100%",
          textAlign: "center",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
        },
      }}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        {ready ? (
          <>
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "text.secondary", mt: 1 }}
            >
              {isMobile
                ? "List is ready! Tap below to download."
                : "List is ready! Tap below to print."}
            </Typography>
            <Button
              variant="contained"
              size="large"
              startIcon={isMobile ? <DownloadIcon /> : <PrintIcon />}
              onClick={onPrint}
              sx={{
                borderRadius: "12px",
                px: 4,
                py: 1.5,
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              {isMobile ? "Download PDF" : "Print Now"}
            </Button>
          </>
        ) : (
          <>
            <CircularProgress color="primary" />
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "text.secondary", mt: 1 }}
            >
              preparing list please wait
            </Typography>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
